import React from 'react';
import './Legal.css';

const Liability: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Release of Liability and Waiver</h1>
        <div className="legal-content">
          <p>
            <strong>PLEASE READ THIS RELEASE OF LIABILITY AND WAIVER CAREFULLY BEFORE USING ANY FREIOLABS SERVICES.</strong>
          </p>
          
          <p>
            This Release of Liability and Waiver ("Release") applies to all applications, websites, services, and digital products 
            developed and operated by FreioLabs ("we," "us," "our," or "Company"). By accessing, downloading, installing, or using 
            any of our Services, you acknowledge that you have read, understood, and agree to be bound by this Release.
          </p>

          <h2>1. Acknowledgment of Risks</h2>
          <p>
            You acknowledge and understand that the use of FreioLabs Services may involve inherent risks, including but not limited to:
          </p>

          <h3>1.1 Technology-Related Risks</h3>
          <ul>
            <li>Software malfunctions, bugs, or errors</li>
            <li>Data loss or corruption</li>
            <li>Security breaches or unauthorized access</li>
            <li>Compatibility issues with devices or operating systems</li>
            <li>Internet connectivity problems</li>
            <li>Server downtime or service interruptions</li>
          </ul>

          <h3>1.2 Content and Information Risks</h3>
          <ul>
            <li>Inaccurate, incomplete, or outdated information</li>
            <li>User-generated content that may be inappropriate or harmful</li>
            <li>Third-party content or advertisements</li>
            <li>Misinformation or misleading guidance</li>
          </ul>

          <h3>1.3 Physical and Health-Related Risks</h3>
          <p>
            For Services that involve physical activities, health guidance, fitness routines, or wellness recommendations:
          </p>
          <ul>
            <li>Physical injury, strain, or discomfort</li>
            <li>Aggravation of existing medical conditions</li>
            <li>Adverse reactions to recommended activities</li>
            <li>Equipment-related injuries</li>
            <li>Environmental hazards during activities</li>
          </ul>

          <h3>1.4 Financial and Commercial Risks</h3>
          <ul>
            <li>Financial loss from in-app purchases or subscriptions</li>
            <li>Investment or business decision risks</li>
            <li>Marketplace transaction risks</li>
            <li>Payment processing errors</li>
          </ul>

          <h2>2. Assumption of Risk</h2>
          <p>
            You voluntarily assume full responsibility for any and all risks associated with your use of FreioLabs Services. 
            You understand that:
          </p>
          <ul>
            <li>No technology is perfect or completely secure</li>
            <li>Our Services are provided for informational and entertainment purposes</li>
            <li>You should exercise your own judgment and discretion</li>
            <li>You are responsible for your own safety and well-being</li>
            <li>You should consult with appropriate professionals before making important decisions</li>
          </ul>

          <h2>3. Release and Waiver of Claims</h2>
          <p>
            In consideration for being permitted to use FreioLabs Services, you hereby release, waive, discharge, and covenant not to sue 
            FreioLabs and its officers, directors, employees, agents, contractors, affiliates, subsidiaries, successors, and assigns 
            (collectively "Released Parties") from any and all liability, claims, demands, actions, and causes of action whatsoever, 
            whether known or unknown, arising out of or related to:
          </p>
          <ul>
            <li>Any loss, damage, or injury that may be sustained by you</li>
            <li>Any property damage or loss</li>
            <li>Any business losses or interruptions</li>
            <li>Any technical failures or malfunctions</li>
            <li>Any unauthorized access to your data</li>
            <li>Any decisions made based on information from our Services</li>
            <li>Any interactions with other users</li>
            <li>Any third-party content or services</li>
          </ul>

          <h2>4. Medical and Professional Disclaimers</h2>
          
          <h3>4.1 Medical Disclaimer</h3>
          <p>
            FreioLabs Services are not intended to provide medical advice, diagnosis, or treatment. You acknowledge that:
          </p>
          <ul>
            <li>You should consult with a healthcare provider before beginning any health, fitness, or wellness program</li>
            <li>Our Services are not a substitute for professional medical advice</li>
            <li>You have been advised to seek medical clearance for physical activities</li>
            <li>You will discontinue use and seek medical attention if you experience any adverse effects</li>
          </ul>

          <h3>4.2 Professional Services Disclaimer</h3>
          <p>
            Our Services do not constitute professional advice in areas such as:
          </p>
          <ul>
            <li>Legal advice or counsel</li>
            <li>Financial or investment advice</li>
            <li>Professional counseling or therapy</li>
            <li>Technical or engineering consultation</li>
            <li>Business or career guidance</li>
          </ul>
          <p>
            You should consult with qualified professionals for advice specific to your situation.
          </p>

          <h2>5. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless the Released Parties from and against any and all claims, 
            liabilities, damages, losses, costs, expenses, fees (including reasonable attorneys' fees and court costs) that 
            arise from or relate to:
          </p>
          <ul>
            <li>Your use or misuse of FreioLabs Services</li>
            <li>Your violation of this Release or our Terms of Service</li>
            <li>Your violation of any rights of third parties</li>
            <li>Your negligent or intentional misconduct</li>
            <li>Any content you submit or share through our Services</li>
          </ul>

          <h2>6. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by applicable law, in no event shall FreioLabs or any Released Party be liable for:
          </p>
          <ul>
            <li>Any direct, indirect, incidental, special, consequential, or punitive damages</li>
            <li>Any loss of profits, revenue, data, use, goodwill, or other intangible losses</li>
            <li>Any damages resulting from unauthorized access to or alteration of your data</li>
            <li>Any damages resulting from the conduct of any user or third party</li>
            <li>Any damages resulting from any content obtained through our Services</li>
          </ul>
          <p>
            This limitation applies regardless of the legal theory on which the claim is based, whether in contract, tort, 
            strict liability, or otherwise, even if FreioLabs has been advised of the possibility of such damages.
          </p>

          <h2>7. No Warranties</h2>
          <p>
            FreioLabs Services are provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind, either express or implied. 
            We specifically disclaim all warranties, including but not limited to:
          </p>
          <ul>
            <li>Warranties of merchantability and fitness for a particular purpose</li>
            <li>Warranties that our Services will be uninterrupted, timely, secure, or error-free</li>
            <li>Warranties that the results obtained from our Services will be accurate or reliable</li>
            <li>Warranties that any defects will be corrected</li>
            <li>Warranties regarding third-party content or services</li>
          </ul>

          <h2>8. Age and Capacity</h2>
          <p>
            You represent and warrant that:
          </p>
          <ul>
            <li>You are at least 18 years of age (or the age of majority in your jurisdiction)</li>
            <li>You have the legal capacity to enter into this Release</li>
            <li>If you are a minor, your parent or guardian has reviewed and agreed to this Release</li>
            <li>You are physically and mentally capable of using our Services safely</li>
          </ul>

          <h2>9. Third-Party Services</h2>
          <p>
            Our Services may integrate with or link to third-party services, websites, or applications. You acknowledge that:
          </p>
          <ul>
            <li>We have no control over third-party services</li>
            <li>We are not responsible for the content, policies, or practices of third parties</li>
            <li>Your use of third-party services is at your own risk</li>
            <li>This Release does not apply to third-party services</li>
          </ul>

          <h2>10. Geographic Limitations</h2>
          <p>
            This Release is governed by the laws of the jurisdiction where FreioLabs operates. You acknowledge that:
          </p>
          <ul>
            <li>Some jurisdictions may not allow certain limitations of liability</li>
            <li>In such cases, our liability is limited to the maximum extent permitted by law</li>
            <li>You may have additional rights under local consumer protection laws</li>
          </ul>

          <h2>11. Severability</h2>
          <p>
            If any provision of this Release is deemed invalid, illegal, or unenforceable by a court of competent jurisdiction, 
            the validity, legality, and enforceability of the remaining provisions shall not be affected or impaired thereby. 
            The invalid provision shall be modified to the minimum extent necessary to make it valid and enforceable.
          </p>

          <h2>12. Entire Agreement</h2>
          <p>
            This Release, together with our Terms of Service and Privacy Policy, constitutes the entire agreement between you and 
            FreioLabs regarding the subject matter herein and supersedes all prior and contemporaneous understandings, agreements, 
            representations, and warranties.
          </p>

          <h2>13. Survival</h2>
          <p>
            The provisions of this Release that by their nature should survive termination of your use of our Services shall survive, 
            including but not limited to the release, waiver, indemnification, limitation of liability, and governing law provisions.
          </p>

          <h2>14. Voluntary Agreement</h2>
          <p>
            You acknowledge that:
          </p>
          <ul>
            <li>You have read and understood this entire Release</li>
            <li>You have had the opportunity to consult with an attorney</li>
            <li>You are entering into this Release voluntarily</li>
            <li>No one has pressured or coerced you to sign this Release</li>
            <li>You understand that you are giving up substantial legal rights</li>
          </ul>

          <h2>15. Electronic Signature</h2>
          <p>
            By using FreioLabs Services, you electronically sign this Release and agree that your electronic signature 
            is the legal equivalent of your manual signature on this Release.
          </p>

          <h2>16. Contact Information</h2>
          <p>
            If you have any questions about this Release of Liability and Waiver, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> legal@freiolabs.com<br/>
            <strong>Website:</strong> freiolabs.com<br/>
            <strong>Subject Line:</strong> Release of Liability Inquiry
          </p>

          <p className="effective-date">
            Last Updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>

          <div className="related-documents">
            <h2>Related Documents</h2>
            <ul>
              <li><a href="/terms">Terms of Service</a></li>
              <li><a href="/privacy">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Liability;